import service from "@/store/services/nuvei-cards-service";

export const state = () => ({
  list: {},
  nuveiCard: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, nuveiCard) => {
    state.nuveiCard = nuveiCard;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((nuveiCard) => {
      commit("SET_RESOURCE", nuveiCard);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((nuveiCard) => {
      commit("SET_RESOURCE", nuveiCard);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((nuveiCard) => {
      commit("SET_RESOURCE", nuveiCard);
    });
  },

  async getNuveiSessionToken({ commit, dispatch }, organizationId) {
    return await service.getNuveiSessionToken(organizationId);
  },

  async initNuveiSession({ commit, dispatch }, params) {
    return await service.initNuveiSession(params);
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  nuveiCard: (state) => state.nuveiCard,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((nuveiCard) => ({
      id: nuveiCard.id,
      name: `${nuveiCard.firstname} ${nuveiCard.lastname}`,
    }));
  },
};

const nuveiCards = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default nuveiCards;
